import { useTranslation } from "react-i18next"
import { Button, Icon, cn } from "@nexus/ui"

import type { PersonasOnboardingCardVariant } from "./persona-onboarding-card.types"

/** Accept commits immediately server-side; Reconsider reverses it back to Suggested. */
export function AcceptedBar({
  onUndo,
  isBusy,
  variant,
}: {
  onUndo?: () => void
  isBusy: boolean
  variant: PersonasOnboardingCardVariant
}) {
  const { t } = useTranslation()
  const isIndustry = variant === "industry"
  const accentClassName = isIndustry ? "text-[var(--competitor)]" : "text-success"
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 px-1 py-1">
      <p className={cn("inline-flex items-center gap-2 text-[13px] font-medium", accentClassName)}>
        <Icon name="check" size="sm" className={cn("shrink-0", accentClassName)} />
        {t(
          isIndustry
            ? "personas.onboarding.industry.acceptedFooter"
            : "personas.onboarding.review.acceptedFooter",
          "Locked in — counts toward coverage",
        )}
      </p>
      {onUndo && (
        <Button type="button" variant="secondary" size="sm" disabled={isBusy} onClick={onUndo}>
          {t(
            isIndustry
              ? "personas.onboarding.industry.reconsider"
              : "personas.onboarding.review.reconsider",
            "Reconsider",
          )}
        </Button>
      )}
    </div>
  )
}
